export default function requiredLegalAge() {
  return false;
}

requiredLegalAge.message = function message(value, options = {}) {
  return options.message || 'precisa ter no mínimo 18 anos';
};
